export default {
  addedSuccessfully: {
    imageUrl: 'https://static.beeline.ru/upload/images/b2c/family-with-beeline/invitation_success.png',
    title: 'Приглашение отправлено',
    description: 'Вы отправили приглашение в семью номеру {{CELLNUMBER}}. Принять его можно в SMS или в личном кабинете на сайте beeline.ru',
    buttonGroup: [
      {
        buttonText: 'Хорошо',
      },
    ],
  },
  notFoundError: {
    arrowText: 'Назад',
    imageUrl: 'https://static.beeline.ru/upload/images/b2c/family-with-beeline/error-popup.svg',
    title: 'Этот номер не в билайне',
    description: 'Чтобы добавить номер в семью, перенесите его в билайн или закажите дополнительную SIM-карту',
    buttonGroup: [
      {
        buttonText: 'Перенести номер в билайн',
        buttonUrl: 'https://www.beeline.ru/customers/products/mobile/services/details/mnp/',
      },
      {
        buttonText: 'Купить SIM-карту',
        buttonUrl: 'https://www.beeline.ru/customers/products/mobile/tariffs/',
      },
    ],
  },
  diffRegionError: {
    arrowText: 'Назад',
    imageUrl: 'https://static.beeline.ru/upload/images/b2c/family-with-beeline/error-popup.svg',
    title: 'Этот номер из другого региона',
    description: 'Чтобы добавить этот номер в семью, закажите новую \nSIM-карту вашего региона',
    buttonGroup: [
      {
        buttonText: 'Купить SIM-карту',
        buttonUrl: 'https://www.beeline.ru/customers/products/mobile/tariffs/',
      },
    ],
  },
  error: {
    imageUrl: 'https://static.beeline.ru/upload/images/b2c/family-with-beeline/warning-triangle.svg',
    title: 'Что-то пошло не так',
    description: 'Повторить попытку или попробуйте позже',
    buttonGroup: [
      {
        buttonText: 'Понятно',
      },
    ],
  },
  delete: {
    imageUrl: 'https://static.beeline.ru/upload/images/b2c/family-with-beeline/delete-child-number.svg',
    title: 'Отключить номер {{CELLNUMBER}} из семьи?',
    buttonGroup: [
      {
        buttonText: 'Отключить',
      },
      {
        buttonText: 'Оставить в семье',
      },
    ],
  },
  deleteSuccess: {
    imageUrl: 'https://static.beeline.ru/upload/images/b2c/family-with-beeline/delete-child-number.svg',
    title: 'Номер {{CELLNUMBER}} отключён',
    buttonGroup: [
      {
        buttonText: 'Хорошо',
      },
    ],
  },
  cancelInvitation: {
    imageUrl: 'https://static.beeline.ru/upload/images/b2c/family-with-beeline/warning-triangle.svg',
    title: 'Отменить приглашение в семью для номера {{CELLNUMBER}}?',
    description: 'Подтвердите отмену приглашения в семью номеру {{CELLNUMBER}}',
    buttonGroup: [
      {
        buttonText: 'Подтвердить',
      },
      {
        buttonText: 'Оставить в семье',
      },
    ],
  },
  saveLimits: {
    imageUrl: 'https://static.beeline.ru/upload/images/b2c/family-with-beeline/save-limits.svg',
    title: 'Применить новые лимиты?',
    buttonGroup: [
      {
        buttonText: 'Применить',
      },
      {
        buttonText: 'Отмена',
      },
    ],
  },
  limitsSavedSuccess: {
    imageUrl: 'https://static.beeline.ru/upload/images/b2c/family-with-beeline/invitation_success.png',
    title: 'Заявка принята',
    description: 'Дождитесь SMS-уведомления',
    buttonGroup: [
      {
        buttonText: 'Хорошо',
      },
    ],
  },
};
